export default "__VITE_ASSET__DQ11LFfD__"